import type { IconifyIcon } from '@iconify/types'

export default {
  body: '<path fill="currentColor" d="m11.414 10l2.829-2.828a1 1 0 1 0-1.415-1.415L10 8.586L7.172 5.757a1 1 0 0 0-1.415 1.415L8.586 10l-2.829 2.828a1 1 0 0 0 1.415 1.415L10 11.414l2.828 2.829a1 1 0 0 0 1.415-1.415zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10"/>',
  left: -2,
  top: -2,
  width: 24,
  height: 24
} satisfies IconifyIcon
